import React, { Component, Suspense } from 'react'
import { Route, Switch, Link, withRouter } from 'react-router-dom'
import { withCookies } from "react-cookie";

import { Loader, Icon, Menu, Responsive, Dropdown } from 'semantic-ui-react'

import ConfirmModal from '../src/components/ConfirmModal/index'

import SiteHeader from '../src/components/SiteHeader'
import ResetPasswordValidate from './components/Forms/ResetPasswordValidate'

const Page = React.lazy(() => import('./pages/Page'))
const UserPage = React.lazy(() => import('./pages/User'))
const BrowseHuntDetails = React.lazy(() => import('./pages/BrowseHuntDetails'))
const Feedback = React.lazy(() => import('./pages/Feedback'))

class THPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: null,
        };
    }

    doLogout = () => {
        this.setState({
            user: null
        });
        this.props.cookies.remove('user');
        if (this.props.history.location.pathname === '/user') {
            window.location.reload()
        } else {
            this.props.history.push('/user')
        }
    }

    render() {
        return (
            <>
                <ConfirmModal
                    ref="modal"
                    content=''
                />
                <div id="page">
                    <SiteHeader
                        doLogout={this.doLogout}
                    />
                        <Suspense fallback={<Loader />}>
                            <Switch>
                                <Route path="/feedback" exact component={Feedback}/>
                                <Route path="/browse/:hunt?" exact component={BrowseHuntDetails}/>
                                <Route path="/user/reset" exact component={ResetPasswordValidate} />
                                <Route path="/user" component={UserPage} />
                                <Route path="/blog/:slug?" exact component={Page} />
                                <Route path="/:slug?/:slug2?/:slug3?/:slug4?" component={Page} />
                            </Switch>
                        </Suspense>

                    <Responsive
                        minWidth={Responsive.onlyComputer.minWidth}
                        as={Menu}
                        className="mastfooter"
                        borderless
                    >
                        <Menu.Item as={Link} to={`${process.env.PUBLIC_URL}/rules-and-advice`}>Rules &amp; Advice</Menu.Item>
                        <Menu.Item as={Link} className="privacy-policy-link" to={`${process.env.PUBLIC_URL}/privacy-policy`}>Privacy Policy</Menu.Item>
                        <Menu.Item as={Link} to={`${process.env.PUBLIC_URL}/feedback`}>Feedback</Menu.Item>
                        <Menu.Item as={Link} to={`${process.env.PUBLIC_URL}/help`}>Help</Menu.Item>
                        <Menu.Item position='right' fitted>
                            <Menu.Item disabled={true}>© { process.env.REACT_APP_YEAR }</Menu.Item>
                            <Menu.Item disabled={true}>Version: { process.env.REACT_APP_VERSION }</Menu.Item>
                        </Menu.Item>
                    </Responsive>
                    <Responsive
                        maxWidth={Responsive.onlyComputer.minWidth - 1}
                        as={Menu}
                        className="mastfooter"
                        borderless
                    >
                        <Dropdown
                            item
                            trigger={<Icon name='bars' />}
                        >
                            <Dropdown.Menu>
                                <Menu.Item as={Link} to={`${process.env.PUBLIC_URL}/rules-and-advice`}>Rules &amp; Advice</Menu.Item>
                                <Menu.Item as={Link} className="privacy-policy-link" to="/privacy-policy">Privacy Policy</Menu.Item>
                                <Menu.Item as={Link} to={`${process.env.PUBLIC_URL}/feedback`}>Feedback</Menu.Item>
                                <Menu.Item as={Link} to={`${process.env.PUBLIC_URL}/help`}>Help</Menu.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Menu.Item position='right' fitted>
                            <Menu.Item disabled={true}>© { process.env.REACT_APP_YEAR }</Menu.Item>
                            <Menu.Item disabled={true}>Version: { process.env.REACT_APP_VERSION }</Menu.Item>
                        </Menu.Item>
                    </Responsive>
                </div>
            </>
        );
    }
}
export default withRouter(withCookies(THPage))